module.exports = __webpack_public_path__ + "00962cf93965bc84578bbaf8408052bd.ttf";